import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { DetailsListModalComponent } from 'src/app/extensions/components/details-list-modal/details-list-modal.component';

@Component({
  selector: 'invoice-card-view',
  templateUrl: './invoice-card-view.component.html',
  styleUrls: ['./invoice-card-view.component.scss'],
  standalone: false,
})
export class InvoiceCardViewComponent {
  public constructor(
    private _ngbModal: NgbModal,
    private _notificationService: NotificationService,
    private _translateService: TranslateService
  ) {}

  @Input() public invoices: app.models.InvoiceListModel[];
  @Input() public props: app.models.DynamicPropsDictionary;
  @Input() public navigateToDetailHandler: any;

  showClipboardNotification(e: Event) {
    e.stopPropagation();

    this._notificationService.showSuccess(
      this._translateService.instant('common.copiedToClipboard'),
      this._translateService.instant('common.success')
    );
  }

  public openDetailsListModalInvoiceContracts = (e: Event, dataList: any[]) => {
    e.stopPropagation();
    const modal = this._ngbModal.open(DetailsListModalComponent, { backdrop: 'static', scrollable: true });
    modal.componentInstance.modalTitle = 'invoice.detailsListModalTitle.contracts';
    modal.componentInstance.dataList = dataList;
  };

  public openDetailsListModalInvoiceCategories = (e: Event, dataList: any[]) => {
    e.stopPropagation();
    const modal = this._ngbModal.open(DetailsListModalComponent, { backdrop: 'static', scrollable: true });
    modal.componentInstance.modalTitle = 'invoice.detailsListModalTitle.categories';
    modal.componentInstance.dataList = dataList;
  };
}
